import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}${`?workOrderId=${number}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}?workOrderId=${workOrderId}`;
